import { useEffect } from 'react';

import { useRouter } from '@/hooks/useRouter';

export const OneTrustScriptReloader = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {
      setTimeout(() => {
        if (
          typeof window !== 'undefined' &&
          typeof window.reloadOTBanner === 'function'
        ) {
          window.reloadOTBanner();
        }
      }, 100);
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  return null;
};
